import { jobStateLabel, type JobState } from '../types/models';

export type StatusBadgeSize = 'sm' | 'md';

/**
 * Job state badge — one colour per state, the same on iOS and web. A tint fill with
 * the state's ink; archived is an outline. Rows omit the dot, elsewhere it reinforces
 * the word. Styles live in index.css (`.state-badge`).
 */
export function StatusBadge({ status, size = 'md' }: { status: JobState; size?: StatusBadgeSize }) {
  return (
    <span className={`state-badge state-${status} ${size === 'sm' ? 'is-sm' : ''}`}>
      {jobStateLabel(status)}
    </span>
  );
}
